(() => {
  if (window.__pulcheKlaviyoAddedToCartInit) return;
  window.__pulcheKlaviyoAddedToCartInit = true;

  const TRACK_EVENT = 'Added to Cart';
  const CART_ADD_PATH = '/cart/add';
  const CART_JSON_URL = `${window.location.origin}/cart.js`;

  const parseMoney = value => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue / 100 : undefined;
  };

  const isTrackableResponse = response => {
    if (!response?.url) return false;

    try {
      const url = new URL(response.url, window.location.origin);
      return url.pathname.includes(CART_ADD_PATH);
    } catch (error) {
      return false;
    }
  };

  const buildTrackedItem = item => {
    if (!item || typeof item !== 'object') return {};

    return {
      Name: item.product_title || item.title,
      ProductID: item.product_id,
      Categories: item.product_type ? [item.product_type] : undefined,
      ImageURL: item.image || undefined,
      URL: item.url ? `${window.location.origin}${item.url}` : undefined,
      Brand: item.vendor || undefined,
      Price: parseMoney(item.price),
      CompareAtPrice: parseMoney(item.original_price),
      OriginalPrice: parseMoney(item.original_price),
      Quantity: item.quantity,
      VariantID: item.variant_id,
      VariantName: item.variant_title || undefined,
      SKU: item.sku || undefined
    };
  };

  const buildCartPayload = (cartData, trackedItem) => {
    const payload = {
      total_price: parseMoney(cartData.total_price),
      $value: parseMoney(cartData.total_price),
      total_discount: cartData.total_discount,
      original_total_price: parseMoney(cartData.original_total_price),
      items: cartData.items
    };

    if (trackedItem && Object.keys(trackedItem).length > 0) {
      return Object.assign(payload, trackedItem);
    }

    return payload;
  };

  const trackAddedToCart = async addedItem => {
    if (!Array.isArray(window._learnq)) return;

    try {
      const response = await fetch(CART_JSON_URL, {
        credentials: 'same-origin'
      });
      const cartData = await response.json();
      const trackedItem = buildTrackedItem(addedItem);
      const payload = buildCartPayload(cartData, trackedItem);

      window._learnq.push(['track', TRACK_EVENT, payload]);
    } catch (error) {
      console.error('Klaviyo Added to Cart tracking failed.', error);
    }
  };

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    if (!isTrackableResponse(response) || !response.ok) {
      return response;
    }

    response
      .clone()
      .json()
      .then(data => {
        if (!data || data.status || data.errors) return;
        trackAddedToCart(data);
      })
      .catch(() => {});

    return response;
  };
})();
